<template>
  <section class="config-group navigation" aria-label="Navigation">
      <div class="row stretch">
            <Checkmark checkbox-id="group-results--i" :label="texts.navigation.groupResults" v-model="config.results.group" hint="https://docs.sitesearch360.com/result-groups"/>
        </div>
      <div class="column" v-if="config.results.group">
        <div class="row stretch" style="margin: 0.5em 0;">
            <label class="nav-1" for="nav-position--rg">{{texts.global.position}}</label>
            <RadioGroup id="nav-position--rg" class="nav-2" :items="positionRadioGroups" name="nav-position" @input="onNavigationPositionSet" style="margin-bottom: 0;"/>
        </div>
        <div class="row stretch" v-if="config.layout.navigation.position!='none'" style="margin: 0.5em 0;" >
            <label  class="nav-1" for="nav-type--rg">{{texts.navigation.type}}</label>
            <RadioGroup  id="nav-type--rg" class="nav-2" :items="typeRadioGroups" name="nav-type" @input="onNavigationTypeSet" style="margin-bottom: 0;"/>
        </div>
        <div class="row stretch" v-if="config.layout.navigation.type=='tabs' && config.layout.navigation.position=='top'" style="margin: 0.5em 0;">
            <Checkmark checkbox-id="tabs-force--i" :label="texts.navigation.forceTabs" v-model="config.layout.navigation.forceTabs"/>
        </div>
        <div class="row stretch" v-if="config.layout.navigation.position!='none' && config.layout.navigation.type=='tabs'" style="margin: 0.5em 0;">
            <label for="tab-spacing--i">{{texts.navigation.spaceBetweenTabs}}</label>
            <input type="number" id="tab-spacing--i" v-model="config.layout.navigation.tabSpacingPx" min="0" max="20"/>
        </div>
        <div  class="row stretch" v-if="config.layout.navigation.position!='none' && config.layout.navigation.type=='tabs'" style="margin: 0.5em 0;">
            <label for="tab-border-radius--i">{{texts.navigation.tabBorderRadius}}</label>
            <input type="number" id="tab-border-radius--i" v-model="config.layout.navigation.borderRadiusPx" min="0" max="15"/>
        </div>
        <div  class="row stretch" v-if="config.layout.navigation.position!='none' && config.layout.navigation.type=='tabs'" style="margin: 0.5em 0;">
            <label for="tab-title--i">{{texts.navigation.tabTitle}}</label>
            <input type="text" id="tab-title--i" v-model="config.layout.navigation.tabTitle"/>
        </div>
      </div>
  </section>
</template>

<script>
import Vue from 'vue';
import RadioGroup from '../RadioGroup';
import Checkmark from "../Checkmark";

export default {
  name: "Navigation",
  components: {RadioGroup, Checkmark},
  props: {
      config: {
          type: Object,
          required: true
      }
  },
  computed: {
      positionRadioGroups(){
          return [
              {
                  id: "nav-none--i",
                  value: "none",
                  isActive: this.config.layout.navigation.position==='none',
                  label: this.texts.navigation.none
              },
              {
                  id: "nav-top--i",
                  value: "top",
                  isActive: this.config.layout.navigation.position==='top',
                  label: this.texts.global.top
              },
              {
                  id: "nav-left--i",
                  value: "left",
                  isActive: this.config.layout.navigation.position==='left',
                  label: this.texts.global.left
              }
          ];
      },
      typeRadioGroups(){
          return [
                {
                    id: "nav-scroll--i",
                    value: "scroll",
                    isActive: this.config.layout.navigation.type==="scroll",
                    label: this.texts.navigation.scroll
                },
                {
                    id: "nav-tabs--i",
                    value: "tabs",
                    isActive: this.config.layout.navigation.type==="tabs",
                    label: this.texts.navigation.tabs
                }
          ];
      }
  },
  methods:{
      onNavigationPositionSet(value){Vue.set(this.config.layout.navigation, 'position', value);},
      onNavigationTypeSet(value){Vue.set(this.config.layout.navigation, 'type', value);}
  }
}
</script>

<style>
    .config-group.navigation > .column{
        width: 100%;
        max-width: 500px;
    }

    .config-group.navigation.active{
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 500px;
        align-items: center;
    }

    @media(min-width: 500px){
        .config-group.navigation{
            margin: 0 calc((100% - 500px)/2);
        }
    }

    #app .nav-1, #app .nav-2{
        flex: 1;
    }

    #app .nav-2{
        justify-content: flex-end;
    }
</style>


// WEBPACK FOOTER //
// src/components/configuration/Navigation.vue